import React from 'react';

import type { Text } from '@zillow/constellation';
import { AdornedInput, Adornment, FormField, Heading, Label, Paragraph } from '@zillow/constellation';
import { CurrencyInput } from '@zillow/zrs-comet';

import type { Section } from '../../../models';
import type { HTMLElementEvent } from '../../../models/Types';
import { BASE_RENT } from '../../../constants';
import { CURRENCY_INPUT_PLACEHOLDER } from '../../../constants/stringConstants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function RentalProtectionBaseRent({ section, setSectionValues }: Props) {
  function onMonthlyBaseRentChange(event: HTMLElementEvent<typeof Text>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [BASE_RENT.FIELD_NAME.AMOUNT]: value,
    });
  }

  return (
    <>
      <Heading level={5} marginBottom="sm">
        Is this the rent amount in the lease you uploaded?
      </Heading>
      <Paragraph marginBottom="sm">
        <strong>Confirm that the amount shown matches the amount in your lease</strong>
      </Paragraph>
      <Paragraph marginBottom="sm">
        The monthly rent amount shouldn’t include any monthly fees, like parking. You’ll be able to add fees when you
        set up payments. If you want the rent amount to be different than the one in the lease, we recommend uploading a
        new lease with the correction.
      </Paragraph>
      <FormField
        label={<Label>Monthly base rent</Label>}
        control={
          <AdornedInput
            leftAdornment={<Adornment>$</Adornment>}
            input={
              <CurrencyInput
                placeholder={CURRENCY_INPUT_PLACEHOLDER}
                value={section.getFieldValue(BASE_RENT.FIELD_NAME.AMOUNT)}
                onChange={onMonthlyBaseRentChange}
                onBlur={onMonthlyBaseRentChange}
              />
            }
          />
        }
      />
    </>
  );
}

export default RentalProtectionBaseRent;
